"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Contact() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return <section id="contact" data-nav="light" className="relative flex min-h-[75vh] w-full items-center justify-center bg-background px-6 py-24 text-center select-text">
      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.4
    }} className="mx-auto flex max-w-xl flex-col items-center justify-center gap-5">
        <motion.p variants={itemVariants} className="font-default text-xs tracking-widest text-muted-foreground uppercase sm:text-sm">
          Please reach out to us at
        </motion.p>

        <motion.div variants={itemVariants}>
          <a href="mailto:contact@slrealtyanddesign.com" className="font-default text-sm tracking-widest text-foreground uppercase underline decoration-foreground/60 underline-offset-8 transition-opacity duration-300 hover:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:text-base">
            contact@slrealtyanddesign.com
          </a>
        </motion.div>

        <motion.p variants={itemVariants} className="font-default text-xs tracking-wider text-muted-foreground sm:text-sm">We would be delighted to hear from you.
</motion.p>
      </motion.div>
    </section>;
}